<h2 class="default-dialog-header" mat-dialog-title>
	<span fxFlex> Select Carrier </span>
	<span fxFlex fxLayoutAlign="end end">
		<mat-icon (click)="closeDialog(null)" class="primary-light-color cursor-pointer"
			>close</mat-icon
		>
	</span>
</h2>
<mat-divider></mat-divider>
<mat-dialog-content class="default-dialog-content">
	<div fxLayout="row" fxLayoutAlign="center center">
		<div fxFlex="95">
			<app-carrier-search-popover
				(setCarrier)="selectedCarrier = $event"
				[carrierSelected]="selectedCarrier"
				[showCloseIcon]="true"
				[useAutoComplete]="true"
				[usePopover]="false"
				customFormFieldClass="custom-form-field"
				fxFlexFill
			>
			</app-carrier-search-popover>
		</div>
		<div fxFlex="5">
			<span *ngIf="IS_NOT_NULL_OR_UNDEFINED(selectedCarrier)">
				<mat-icon (click)="selectedCarrier = null" class="danger-text cursor-pointer"
					>close</mat-icon
				>
			</span>
		</div>
	</div>
	<mat-divider></mat-divider>
</mat-dialog-content>

<mat-dialog-actions class="default-dialog-action">
	<div fxFlex="100" fxLayoutAlign="end end" fxLayoutGap="0.5rem">
		<button
			(click)="closeDialog(selectedCarrier)"
			[disabled]="IS_NULL_OR_UNDEFINED(selectedCarrier)"
			color="primary"
			mat-raised-button
		>
			Select
		</button>
	</div>
</mat-dialog-actions>
